export function getSchemaNamespace(schemaId) {
    const index = schemaId.lastIndexOf('/');
    return index > -1 ? schemaId.substring(0, index) : null;
}
export function getSchemaName(schemaId) {
    const index = schemaId.lastIndexOf('/');
    return index > -1 ? schemaId.substring(index + 1) : schemaId;
}
export function parseSchemaId(schemaId) {
    return {
        namespace: getSchemaNamespace(schemaId),
        name: getSchemaName(schemaId),
    };
}
//# sourceMappingURL=schema-id-utils.js.map